import styled from '@emotion/styled'
import { css } from '@emotion/react'

const ItemStyles = ({ theme }) => css`
  label: item;

  padding-bottom: ${theme.spacings.mega};
  margin-bottom: ${theme.spacings.mega};
  border-bottom: 1px solid ${theme.colors.n200};
`

const radioButtonStyles = ({ theme }) => css`
  label: item__radio-button;

  width: 20px;
  height: 20px;

  margin-right: ${theme.spacings.mega};

  appearance: none;
  cursor: pointer;

  border: 1px solid ${theme.colors.n500};
  border-radius: ${theme.borderRadius.circle};

  background: transparent;

  position: relative;
  transition: all 400ms ease-in-out;

  &::before {
    content: '';

    position: absolute;
    display: block;

    width: 45%;
    height: 45%;

    background: ${theme.colors.white};

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    margin: auto;

    border-radius: ${theme.borderRadius.circle};
    opacity: 0;
    transition: all 400ms ease-in-out;
  }

  &:checked {
    background: green;

    &::before {
      opacity: 1;
    }
  }
`

const radioButtonLabelStyles = () => css`
  label: item__radio-button-label;

  display: flex;
  align-items: center;
`

export const Item = styled('li')(ItemStyles)
export const RadioButton = styled('input')(radioButtonStyles)
export const RadioButtonLabel = styled('label')(radioButtonLabelStyles)
